import { css, styled } from "styled-components";

import { EMPTY_STRING } from "@/constants";

import { TLevelButtonStatus } from "../../interfaces";

export const LevelButtonContainer = styled.div`
  width: 100%;

  display: flex;
  gap: 1rem;

  flex-direction: column;
  align-items: center;
  padding: 0.75rem;

  border-radius: 1.25rem;
  background-color: ${({ theme }) => theme.colors.white};
`;

const LevelButton = styled.div<{ $disabled: boolean }>`
  cursor: pointer;

  width: 100%;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  color: ${({ theme }) => theme.colors.black};
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`;

const LevelButtonIcon = styled.div<{ $bg?: string }>`
  width: 2.5rem;
  height: 2.5rem;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 0.5rem;

  ${({ theme, $bg }) =>
    $bg
      ? css`
          color: ${theme.colors.white};
          background-color: ${$bg};
        `
      : css`
          border: 1px solid #c7c3c1;
        `}
`;

const LevelButtonBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  & > p {
    text-align: start;
    font-variant-numeric: stacked-fractions;
    font-size: 1rem;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.02rem;
  }
`;

const LevelButtonStatus = styled.div<{ $status: TLevelButtonStatus }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  font-variant-numeric: stacked-fractions;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0175rem;

  ${({ $status, theme }) => {
    switch ($status) {
      case "completed":
        return css`
          color: ${theme.colors.green};
        `;

      case "pending":
        return css`
          color: ${theme.colors.warning};
        `;

      default:
        return EMPTY_STRING;
    }
  }}

  svg {
    width: 0.9375rem;
    height: 0.9375rem;
  }
`;

export default {
  LevelButton,
  LevelButtonIcon,
  LevelButtonBody,
  LevelButtonStatus,
};
